exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AccountState_row_36oQ {\n  margin-bottom: 5px;\n}\n\n.AccountState_label_1u65 {\n  margin-right: 10px;\n\n  display: inline-block;\n\n  min-width: 100px;\n\n  color: #787878;\n}\n\n.AccountState_balanceCalculationLabel_3vwZ {\n  display: inline-block;\n\n  line-height: 17px;\n\n  border-bottom: 1px solid rgba(40, 40, 40, .33);\n\n  cursor: pointer\n}\n\n.AccountState_balanceCalculationLabel_3vwZ:hover {\n  color: #f6a000;\n  border-bottom-color: rgba(246, 160, 0, .33);\n}\n", ""]);

// exports
exports.locals = {
	"row": "AccountState_row_36oQ",
	"label": "AccountState_label_1u65",
	"balanceCalculationLabel": "AccountState_balanceCalculationLabel_3vwZ"
};